<template>
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.83202 14.8393C8.59819 15.0944 9.436 14.8485 9.94401 14.2349V20L3.27732 17.4886V13.322L7.83202 14.8393Z"
      fill="currentColor"
    />
    <path
      d="M17.722 17.4886L11.0553 20V14.2349C11.5634 14.8485 12.4018 15.0945 13.168 14.8393L17.722 13.322V17.4886Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.3184 5.02729C10.4361 4.98662 10.5639 4.98661 10.6816 5.02729L17.903 7.52502C17.9076 7.52659 17.9121 7.52855 17.9167 7.53023C18.0167 7.56758 18.1003 7.63082 18.1615 7.7098L20.3783 10.4795C20.4917 10.6212 20.5287 10.8097 20.4773 10.9837C20.4258 11.1577 20.2921 11.2952 20.1198 11.3526L12.6198 13.851C12.3866 13.9286 12.1306 13.844 11.9896 13.6428L10.5 11.5166L9.01042 13.6428C8.86947 13.8441 8.61278 13.9287 8.37955 13.851L0.879523 11.3526C0.707461 11.2952 0.574222 11.1576 0.522751 10.9837C0.471313 10.8097 0.508273 10.6212 0.62171 10.4795L2.83852 7.7098C2.90006 7.63039 2.98388 7.56687 3.08461 7.52958L3.09698 7.52502L10.3184 5.02729ZM4.97589 8.05007L10.5 9.96094L16.0241 8.05007L10.5 6.1392L4.97589 8.05007Z"
      fill="currentColor"
    />
    <path
      d="M11.7734 0.162611C11.9904 -0.0542037 12.3423 -0.0542037 12.5593 0.162611C12.7762 0.379433 12.7762 0.731095 12.5593 0.947909L11.2858 2.22052L12.5593 3.49378C12.7761 3.71058 12.7761 4.06166 12.5593 4.27843C12.3423 4.49529 11.9904 4.49529 11.7734 4.27843L10.5 3.00582L9.22591 4.27843C9.00892 4.49523 8.65774 4.49523 8.44075 4.27843C8.22381 4.06163 8.22382 3.71059 8.44075 3.49378L9.71419 2.22052L8.44075 0.947909C8.22375 0.731088 8.22375 0.379432 8.44075 0.162611C8.6577 -0.0541671 9.00963 -0.0541915 9.22656 0.162611L10.5 1.43522L11.7734 0.162611Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SoldOutBanner',
} as DefineComponent
</script>
